export const generateBeautifulDate = (date: string) => {
  const dateObject = new Date(date);

  return dateObject.toLocaleDateString("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
};
